export const Heading = {
  h1: ({ children }: any) => (
    <h1
      // style={{
      //   display: 'block',
      //   fontSize: '2em',
      //   marginTop: '0.67em',
      //   marginBottom: '0.67em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   fontWeight: '700',
      //   lineHeight: '50px',
      // }}
      className="slug_heading-1"
    >
      {children}
    </h1>
  ),
  h2: ({ children }: any) => (
    <h2
      // style={{
      //   display: 'block',
      //   fontSize: '1.5em',
      //   marginTop: '0.83em',
      //   marginBottom: '0.83em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   lineHeight: '50px',
      //   fontWeight: '700',
      // }}
      className="slug_heading-2"
    >
      {children}
    </h2>
  ),
  h3: ({ children }: any) => (
    <h3
      // style={{
      //   display: 'block',
      //   fontSize: '1.17em',
      //   marginTop: '1em',
      //   marginBottom: '1em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   lineHeight: '50px',
      //   fontWeight: '700',
      // }}
      className="slug_heading-3"
    >
      {children}
    </h3>
  ),
  h4: ({ children }: any) => (
    <h4
      // style={{
      //   display: 'block',
      //   marginTop: '1.33em',
      //   marginBottom: '1.33em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   fontWeight: '700',
      //   lineHeight: '50px',
      // }}
      className="slug_heading-4"
    >
      {children}
    </h4>
  ),
  h5: ({ children }: any) => (
    <h5
      // style={{
      //   display: 'block',
      //   fontSize: '.83em',
      //   marginTop: '1.67em',
      //   marginBottom: '1.67em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   lineHeight: '50px',
      //   fontWeight: '700',
      // }}
      className="slug_heading-5"
    >
      {children}
    </h5>
  ),
  h6: ({ children }: any) => (
    <h6
      // style={{
      //   display: 'block',
      //   fontSize: '.67em',
      //   marginTop: '2.33em',
      //   marginBottom: '2.33em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   lineHeight: '50px',
      //   fontWeight: '700',
      // }}
      className="slug_heading-6"
    >
      {children}
    </h6>
  ),
};

export const Primary = {
  p: ({ children }: any) => (
    <p
      // style={{
      //   display: 'block',
      //   marginTop: '1em',
      //   marginBottom: '1em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   lineHeight: '32px !important',
      // }}
      className="slug_p"
    >
      {children}
    </p>
  ),
  strong: ({ children }: any) => (
    <strong
      // style={{
      //   fontWeight: 'bold',
      // }}
      className="slug_strong"
    >
      {children}
    </strong>
  ),
  em: ({ children }: any) => (
    <em
      // style={{
      //   fontStyle: 'italic',
      // }}
      className="slug_em"
    >
      {children}
    </em>
  ),
  ul: ({ children }: any) => (
    <ul
      // style={{
      //   display: 'block',
      //   listStyleType: 'disc',
      //   marginTop: '1em',
      //   marginBottom: '1 em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   paddingLeft: '40px',
      // }}
      className="slug_ul"
    >
      {children}
    </ul>
  ),
  li: ({ children }: any) => (
    <li
      // style={{
      //   display: 'list-item',
      // }}
      className="slug_li"
    >
      {children}
    </li>
  ),
  blockquote: ({ children }: any) => (
    <blockquote
      // style={{
      //   display: 'block',
      //   marginTop: '1em',
      //   marginBottom: '1em',
      //   marginLeft: '40px',
      //   marginRight: '40px',
      // }}
      className="slug_blockquote"
    >
      {children}
    </blockquote>
  ),
  ol: ({ children }: any) => (
    <ol
      // style={{
      //   display: 'block',
      //   listStyleType: 'decimal',
      //   marginTop: '1em',
      //   marginBottom: '1em',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   paddingLeft: '40px',
      // }}
      className="slug_ol"
    >
      {children}
    </ol>
  ),
};

export function CustomImage({ src, alt, ...props }: any) {
  return <img src={src} width="100%" alt={alt} {...props} />;
}

export function CustomIframe({ src, width, height, ...props }: any) {
  return <iframe width={width} height={height} src={src} {...props}></iframe>;
}

export function CustomGuideImage({ src, alt, ...props }: any) {
  return (
    <img
      src={`${process.env.NEXT_PUBLIC_AMPLIFY_STRAPI_BASE_URL}${src}`}
      width="100%"
      alt={alt}
      {...props}
    />
  );
}

export const GuideComponents = {
  p: ({ children }: any) => (
    <p
      // style={{
      //   display: 'block',
      //   marginLeft: '0',
      //   marginRight: '0',
      //   lineHeight: '32px !important',
      // }}
      className="slug_p-guide"
    >
      {children}
    </p>
  ),
};
